import * as React from "react";
import { useEffect } from "react";
import { Feature } from "ol";
import { IDocument, IRelatedDocs } from "../interfaces";
import { useCustomViewContext } from "../Contexts/CustomViewContext";
import "./DocsSection.scss";

export const DocsSection = ({ feature, title }: { feature: Feature; title: string }): JSX.Element => {
    const { relatedDocs } = useCustomViewContext();

    const objectId = feature.get("OBJECTID");
    let objectDocs = relatedDocs.find((item: IRelatedDocs) => (item.objectId === objectId ? item.docs : undefined));

    useEffect(() => {
        objectDocs = relatedDocs.find((item: IRelatedDocs) => (item.objectId === objectId ? item.docs : undefined));
    }, [relatedDocs]);

    return objectDocs ? (
        <>
            <div className="docs-title">{title}</div>
            <div className="docs-section">
                <DocumentList docs={objectDocs.docs}></DocumentList>
            </div>
        </>
    ) : null;
};

export const DocumentList = ({ docs }: { docs: IDocument[] }): JSX.Element => {
    return (
        <>
            {docs.map((doc, i) => (
                <div className="popup-row" key={"download-popup-row-" + i}>
                    <div className="url-title">{doc.title}</div>
                    <a className="url" href={doc.url} rel="noopener noreferrer" target="_blank">
                        {doc.fileName}
                    </a>
                </div>
            ))}
        </>
    );
};
